<template>
  <router-view />
</template>

<script setup>
  import { isWeiXinLogin } from '@/utils/appid';
  import { onMounted } from 'vue';
  onMounted(() => {
    isWeiXinLogin();
  })
 </script> 

<style lang="scss">
// 全局主题色变量
$theme-color: #92C5C6;

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body.keyboard-active {
  position: fixed;
  width: 100%;
}

// NutUI 主题色覆盖
:root {
  --nutui-color-primary: #{$theme-color};
  --nutui-color-primary-stop-1: #{$theme-color};
  --nutui-color-primary-stop-2: #{$theme-color};
}

// 按钮主题色
.nut-button--primary {
  background: $theme-color !important;
  border-color: $theme-color !important;
  
  &:active {
    background: darken($theme-color, 5%) !important;
    border-color: darken($theme-color, 5%) !important;
  }
  
  &:disabled {
    background: #c8c9cc !important;
    border-color: #c8c9cc !important;
  }
}

// 单选框主题色
.nut-radio-button {
  &.nut-radio-button--active {
    background: $theme-color !important;
    border-color: $theme-color !important;
    color: #fff !important;
  }
}

.nut-radio__icon {
  &.nut-radio__icon--checked {
    color: $theme-color !important;
  }
}

// 复选框主题色
.nut-checkbox__icon {
  &.nut-checkbox__icon--checked {
    background: $theme-color !important;
    border-color: $theme-color !important;
  }
}

// 日期选择器确认按钮
.nut-date-picker__confirm {
  color: $theme-color !important;
}

// Tabs 主题色
.nut-tabs__titles-item {
  &.nut-tabs__titles-item--active {
    color: $theme-color !important;
  }
}

.nut-tabs__titles-item__line {
  background: $theme-color !important;
}

// 弹窗确认按钮
.nut-popup {
  .nut-button--primary {
    background: $theme-color !important;
    border-color: $theme-color !important;
  }
}
</style>
